import _regeneratorRuntime from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Numeric, Serialize } from 'eosjs';
import * as ecc from 'eosjs-ecc';
import linkAbi from './link-abi-data';
/** @internal */

var types = Serialize.getTypesFromAbi(Serialize.createInitialTypes(), linkAbi);
/**
 * Helper to ABI encode value.
 * @internal
 */

export function abiEncode(value, typeName) {
  var type = types.get(typeName);

  if (!type) {
    throw new Error("No such type: ".concat(typeName));
  }

  var buf = new Serialize.SerialBuffer();
  type.serialize(buf, value);
  return buf.asUint8Array();
}
/**
 * Helper to ABI decode data.
 * @internal
 */

export function abiDecode(data, typeName) {
  var type = types.get(typeName);

  if (!type) {
    throw new Error("No such type: ".concat(typeName));
  }

  if (typeof data === 'string') {
    data = Serialize.hexToUint8Array(data);
  } else if (!(data instanceof Uint8Array)) {
    data = new Uint8Array(data);
  }

  var buf = new Serialize.SerialBuffer({
    array: data
  });
  return type.deserialize(buf);
}
/**
 * Encrypt a message using AES and shared secret derived from given keys.
 * @internal
 */

export function sealMessage(message, privateKey, publicKey) {
  var res = ecc.Aes.encrypt(privateKey, publicKey, message);
  var data = {
    from: ecc.privateToPublic(privateKey),
    nonce: res.nonce.toString(),
    ciphertext: res.message,
    checksum: res.checksum
  };
  return abiEncode(data, 'sealed_message');
}
/**
 * Ensure public key is in new PUB_ format.
 * @internal
 */

export function normalizePublicKey(key) {
  if (key.startsWith('PUB_')) {
    return key;
  }

  return Numeric.publicKeyToString(Numeric.stringToPublicKey('EOS' + key.substr(-50)));
}
/**
 * Return true if given public keys are equal.
 * @internal
 */

export function publicKeyEqual(keyA, keyB) {
  return normalizePublicKey(keyA) === normalizePublicKey(keyB);
}
/**
 * Generate a random private key.
 * Uses browser crypto if available, otherwise falls back to slow eosjs-ecc.
 * @internal
 */

export function generatePrivateKey() {
  return _generatePrivateKey.apply(this, arguments);
}

function _generatePrivateKey() {
  _generatePrivateKey = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof window !== 'undefined' && window.crypto)) {
              _context.next = 6;
              break;
            }

            data = new Uint32Array(32);
            window.crypto.getRandomValues(data);
            return _context.abrupt("return", ecc.PrivateKey.fromBuffer(Buffer.from(data)).toString());

          case 6:
            _context.next = 8;
            return ecc.randomKey();

          case 8:
            return _context.abrupt("return", _context.sent);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _generatePrivateKey.apply(this, arguments);
}